import "./common.scss";


interface CustomIframeLoaderInterface {
    iframeURL: string;
    fileName: string;
}

const CustomIframeLoader = (props: CustomIframeLoaderInterface) => {
    const { iframeURL, fileName } = props;
    return <iframe
        id="diff-iframe"
        src={iframeURL}
        title={fileName}
        style={{ height: "100vh", marginBottom: "55px", padding: "0", width: "100%" }}
    ></iframe>
}

export default CustomIframeLoader;